<template>

  <div>
      <b-card >
        <b-table cols="auto" responsive class="text-left" :items="domains" :fields="domainFields" >
          <template slot="available" slot-scope="row">
            <b-input  v-model="row.item['authinfo']"
                      v-if="row.item.available === 'false'"
                      placeholder="Authcode bitte eingeben"
                      value="0">
            </b-input>
            <span class="error small" v-if="row.item.available === 'false'">Domain ist bereits registriert</span>
            <p v-else class="available">Verfügbar</p>
          </template>
          <template slot="Auswahl" slot-scope="row" >
            <b-link @click="deleteSearchItem(row.item.name)"><i class="fa fa-close"></i></b-link>
          </template>
          <template slot="Preis" slot-scope="row">
            <p v-if="row.item.tld">
              {{row.item.price}}
            </p>
          </template>
          <template slot="Laufzeit_:_Jahre" slot-scope="row" >
            <select class=" form-control" v-model="row.item['year']" >
              <option v-for="i in 10">{{i}}</option>
            </select>
          </template>
        </b-table>
      </b-card>
  </div>

</template>

<script>
  import DomainSearchResult from "@/store/models/layout/domain_search_result"
    export default {
      name: "luma-table",
      data: () => ({
        domainFields: [
          {key: 'name', lable: 'Name', sortable: true},
          {key: 'available', label: 'Status', sortable: true},
          {key: 'price', label: 'Preis €', sortable: true},
          'Laufzeit_:_Jahre',
          'Auswahl'
        ]
      }),
      computed: {
        domains() {
          const y = []
          const x = DomainSearchResult.all().map(el=>{
            if(!el.success) y.push(el)
          })
          return y
        }
      },
      methods: {
        deleteSearchItem(index){
          DomainSearchResult.deleteSearchItem(index)
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/domain/create_domain/LumaTable.vue